/**
 * featured-collection セクションの slider-component に autoplay を追加。
 * Dawn の SliderComponent クラスは触らず、外側から「次へ」ボタンを定期クリック。
 *
 * 対象: <div class="shopify-section[..featured_collection..]"> 内の <slider-component>
 *
 * 挙動:
 *   - 5秒ごとに自動で次のスライドへ
 *   - 末尾に到達したら先頭にスムーススクロールで戻る（無限ループ）
 *   - マウスホバー / フォーカス中は一時停止
 *   - ユーザーが矢印を押したら一時停止して 10 秒後に再開
 *   - タブ非表示時は停止
 *   - prefers-reduced-motion: reduce のユーザーには動かさない
 */
(function () {
  const DEFAULT_INTERVAL_MS = 5000;
  const RESUME_AFTER_USER_MS = 10000;

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setupAutoplay(el) {
    const slider = el.querySelector('[id^="Slider-"]');
    const nextButton = el.querySelector('button[name="next"]');
    if (!slider || !nextButton) return;

    const interval = parseInt(el.dataset.autoplayInterval, 10) || DEFAULT_INTERVAL_MS;
    let timer = null;
    let userPaused = false;
    let hovered = false;

    function tick() {
      if (hovered || userPaused || document.hidden) return;
      // 末尾なら先頭に戻る
      if (nextButton.hasAttribute('disabled')) {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        nextButton.click();
      }
    }

    function start() {
      stop();
      timer = setInterval(tick, interval);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    el.addEventListener('mouseenter', () => { hovered = true; });
    el.addEventListener('mouseleave', () => { hovered = false; });
    el.addEventListener('focusin', () => { hovered = true; });
    el.addEventListener('focusout', () => { hovered = false; });

    // ユーザーが矢印操作したら少し待ってから再開
    el.addEventListener('click', (e) => {
      if (e.target.closest('.slider-button')) {
        userPaused = true;
        clearTimeout(el._tsResumeTimer);
        el._tsResumeTimer = setTimeout(() => { userPaused = false; }, RESUME_AFTER_USER_MS);
      }
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop(); else start();
    });

    start();
  }

  function init() {
    if (reduceMotion()) return;
    // featured-collection セクション内の slider-component をすべて対象に
    document.querySelectorAll(
      '.shopify-section[id*="featured_collection"] slider-component, slider-component[data-autoplay]'
    ).forEach(setupAutoplay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
